import { render, staticRenderFns } from "./sharePayDialog.vue?vue&type=template&id=5b68efbe&scoped=true"
import script from "./sharePayDialog.vue?vue&type=script&lang=js"
export * from "./sharePayDialog.vue?vue&type=script&lang=js"
import style0 from "./sharePayDialog.vue?vue&type=style&index=0&id=5b68efbe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b68efbe",
  null
  
)

export default component.exports